module.exports = __webpack_public_path__ + "static/media/behance.729dca08.jpg";